import type { DocumentData } from "firebase/firestore";
import { dateValue, stringList, stringValue } from "./firestore";
import { USER_ROLES, type SBotUserRole } from "./user";

// Mirrors firestore.rules validLeagueMemberSummaryShape — top-level collection
// `leagueMemberSummaries`, doc id `${leagueID}_${userID}`. System-managed; the
// web only reads these.

export interface LeagueMemberSummary {
  id: string;
  leagueID: string;
  userID: string;
  displayName: string;
  photoURL?: string;
  roles: SBotUserRole[];
  organizationIDs: string[];
  organizationNames: string[];
  createdAt?: Date;
  updatedAt?: Date;
}

export function parseMemberSummary(id: string, data: DocumentData): LeagueMemberSummary | null {
  const leagueID = stringValue(data.leagueID);
  const userID = stringValue(data.userID);
  const displayName = stringValue(data.displayName);
  if (!leagueID || !userID || !displayName) return null;
  return {
    id,
    leagueID,
    userID,
    displayName,
    photoURL: stringValue(data.photoURL),
    roles: stringList(data.roles).filter((role): role is SBotUserRole => (USER_ROLES as string[]).includes(role)),
    organizationIDs: stringList(data.organizationIDs),
    organizationNames: stringList(data.organizationNames),
    createdAt: dateValue(data.createdAt),
    updatedAt: dateValue(data.updatedAt),
  };
}
